import ContactForm from "../components/ContactForm";

export default function Contact() {
  return (
    <main data-testid="contact-page" className="pt-20">
      <ContactForm />
    </main>
  );
}
